import { render, staticRenderFns } from "./MiniVoteDetail.vue?vue&type=template&id=77860aef"
import script from "./MiniVoteDetail.vue?vue&type=script&lang=js"
export * from "./MiniVoteDetail.vue?vue&type=script&lang=js"
import style0 from "./MiniVoteDetail.vue?vue&type=style&index=0&id=77860aef&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports